/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Button,
  Col,
  InputGroup,
  Row,
  Form,
  Table,
  Modal,
  Container,
  Card
} from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import ModalStockAdjustment from '../../../components/modal/stockAdjustment/ModalStockAdjustment'
import { Search, Trash2, Edit2 } from 'lucide-react'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import { Loader } from 'react-bootstrap-typeahead'
import RowEmpty from '../../../components/atoms/RowEmpty'
import * as Common from '../../../utils/Common'
import api from '../../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

function CreateTransferRackPage() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const debounceTimeout = useRef(null)
  const abortControllerRef = useRef(null)
  const [visible, setVisible] = useState({
    pallet: false,
    slot: false,
    cancel: false,
    create: false
  })
  const [data, setData] = useState({
    values: [],
    isFetch: false,
    metaData: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })
  const [selectedSlotItemId, setSelectedSlotItemId] = useState(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState({
    pallet: false,
    slot: false,
    submit: false
  })
  const [selected, setSelected] = useState({
    pallet: [],
    slot: []
  })
  const [payload, setPayload] = useState({
    pallet: []
  })
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [editingItem, setEditingItem] = useState(null)
  const [editPickedPack, setEditPickedPack] = useState('')
  const [editPickedQty, setEditPickedQty] = useState('')

  const handleOpenEditModal = (item) => {
    setEditingItem(item)
    setEditPickedPack(String(item.picked_pack))
    setEditPickedQty(String(item.picked_qty))
    setShowUpdateModal(true)
  }

  const handleEditPackChange = (val) => {
    setEditPickedPack(val)
    const pack = parseFloat(val) || 0
    const factor = parseFloat(editingItem?.convertion_factor_pack || 1)
    setEditPickedQty(String((pack * factor).toFixed(2)))
  }

  const handleEditQtyChange = (val) => {
    setEditPickedQty(val)
    const qty = parseFloat(val) || 0
    const factor = parseFloat(editingItem?.convertion_factor_pack || 1)
    setEditPickedPack(String(factor > 0 ? (qty / factor).toFixed(4) : 0))
  }

  const handleSaveEdit = () => {
    const pack = parseFloat(editPickedPack) || 0
    const qty = parseFloat(editPickedQty) || 0
    const avail = parseFloat(editingItem?.total_pack || 0)

    if (pack <= 0 || qty <= 0) {
      return Common.showPopUpErrorMessage(
        'Picked quantity must be greater than 0'
      )
    }
    if (pack > avail) {
      return Common.showPopUpErrorMessage(
        `Picked Qty Kemasan cannot exceed available (${avail})`
      )
    }

    setPayload((prevPayload) => {
      const newPallet = prevPayload.pallet.map((parent) => {
        const isParentEditing = parent.slot_item_id === editingItem.slot_item_id
        const newItems = parent.items.map((sub) =>
          sub.slot_item_id === editingItem.slot_item_id
            ? { ...sub, picked_pack: pack, picked_qty: qty }
            : sub
        )
        if (
          isParentEditing ||
          newItems.some((sub) => sub.slot_item_id === editingItem.slot_item_id)
        ) {
          return {
            ...parent,
            ...(isParentEditing ? { picked_pack: pack, picked_qty: qty } : {}),
            items: newItems
          }
        }
        return parent
      })
      return { ...prevPayload, pallet: newPallet }
    })
    setShowUpdateModal(false)
  }
  const handleSelectedSlot = (dataSlot) => {
    setSelected((prevSelected) => ({
      ...prevSelected,
      slot: [...prevSelected.slot, dataSlot]
    }))
    setPayload((prevPayload) => ({
      ...prevPayload,
      pallet: prevPayload.pallet?.map((pallet) =>
        pallet.slot_item_id === selectedSlotItemId
          ? { ...pallet, destination_slot: dataSlot }
          : pallet
      )
    }))
    setSelectedSlotItemId(null)
    handleClose()
  }

  const handleRemoveSubItem = (parentId, subItemId) => {
    setPayload((prevPayload) => {
      const newPallet = prevPayload.pallet
        .map((parent) => {
          if (parent.slot_item_id === parentId) {
            return {
              ...parent,
              items: parent.items.filter(
                (sub) => sub.slot_item_id !== subItemId
              )
            }
          }
          return parent
        })
        .filter((parent) => parent.items.length > 0)
      return { ...prevPayload, pallet: newPallet }
    })
  }

  const handleRemoveDataTransfer = (slotItemId) => {
    const dataSelectedPallet = payload.pallet?.find(
      (pallet) => pallet.slot_item_id === slotItemId
    )
    if (dataSelectedPallet) {
      setPayload((prevPayload) => ({
        ...prevPayload,
        pallet: prevPayload.pallet.filter(
          (pallet) => pallet.slot_item_id !== slotItemId
        )
      }))
      setSelected((prevSelected) => ({
        ...prevSelected,
        pallet: prevSelected.pallet.filter(
          (pallet) => pallet.slot_item_id !== slotItemId
        ),
        slot: dataSelectedPallet.destination_slot
          ? prevSelected.slot.filter(
              (slot) => slot.slot !== dataSelectedPallet.slot
            )
          : prevSelected.slot
      }))
    }
  }
  const COLUMN_SLOT = [
    { key: 'rack', label: 'Rack Name' },
    { key: 'slot', label: 'Slot Name' },
    {
      key: 'action',
      label: 'Action',
      component: (data) => (
        <div key={data.slot_id}>
          <Button
            className={`${
              payload.pallet.find(
                (pallet) => pallet.destination_slot?.slot_id === data.slot_id
              )
                ? 'btn-secondary opacity-24'
                : 'btn-primary-blue'
            } fw-bold`}
            onClick={() => handleSelectedSlot(data)}
            disabled={
              payload.pallet.find(
                (pallet) => pallet.destination_slot?.slot_id === data.slot_id
              )
                ? true
                : false
            }
          >
            Select
          </Button>
        </div>
      )
    }
  ]
  const COLUMN_PALLET = [
    { key: 'checkbox', label: 'checkbox' },
    { key: 'slot', label: 'Slot Name' },
    { key: 'palet_id', label: 'Palet ID' },
    { key: 'area', label: 'Area' },
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (data) => `${data.item_code || ''} - ${data.item_name || ''}`
    },
    { key: 'batch', label: 'Batch' },
    { key: 'exp_date', label: 'Exp Date' },
    {
      key: 'total_pack',
      label: 'Total Qty Kemasan',
      component: (data) => `${data.total_pack || 0} ${data.uom_pack || ''}`
    },
    {
      key: 'total_qty',
      label: 'Total Base Qty UOM',
      component: (data) => `${data.total_qty || 0} ${data.uom_qty || ''}`
    }
  ]
  const handleClose = () => {
    const propertyVisible = Object.keys(visible).find(
      (key) => visible[key] === true
    )
    if (propertyVisible) {
      setVisible({ ...visible, [propertyVisible]: false })
    }
    setData({
      values: [],
      isFetch: false,
      metaData: {
        per_page: 10,
        current_page: 1,
        total_row: 0,
        total_page: 0
      }
    })
    setSearch('')
    if (selectedSlotItemId) {
      setSelectedSlotItemId(null)
    }
  }
  const getDataModal = () => {
    const propertyVisible = Object.keys(visible).find(
      (key) => visible[key] === true
    )
    if (propertyVisible === 'pallet') {
      return {
        title: 'Select Pallet to move',
        size: 'xl'
      }
    } else if (propertyVisible === 'slot') {
      return {
        title: 'Select Available Slot',
        size: 'lg'
      }
    }
    return {
      title: '',
      size: 'md'
    }
  }
  const handleOnChangeMeta = (e) => {
    setData((prevData) => ({
      ...prevData,
      metaData: {
        ...prevData.metaData,
        per_page: parseInt(e.target.value, 10),
        current_page: 1
      }
    }))
    const tmpSelectedPallet = selected.pallet?.map(
      (pallet) => pallet.slot_item_id
    )
    const filterPayloadPalletLength = payload.pallet.filter((payloadPallet) =>
      tmpSelectedPallet.includes(payloadPallet.slot_item_id)
    )?.length
    if (selected.pallet.length > 0 && !filterPayloadPalletLength) {
      setSelected((prevSelected) => ({
        ...prevSelected,
        pallet: []
      }))
    }
  }
  const handlePageChange = (data) => {
    setData((prevData) => ({
      ...prevData,
      metaData: { ...prevData.metaData, current_page: data.selected + 1 }
    }))
    const tmpSelectedPallet = selected.pallet?.map(
      (pallet) => pallet.slot_item_id
    )
    const filterPayloadPalletLength = payload.pallet.filter((payloadPallet) =>
      tmpSelectedPallet.includes(payloadPallet.slot_item_id)
    )?.length
    if (selected.pallet.length > 0 && !filterPayloadPalletLength) {
      setSelected((prevSelected) => ({
        ...prevSelected,
        pallet: []
      }))
    }
    window.scrollTo(0, 0)
  }
  const getDataPallet = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, pallet: true }))
      const params = {
        warehouse_id: state?.warehouse_id || '',
        per_page: data.metaData.per_page || 10,
        page: data.metaData.current_page || 1,
        q: search || ''
      }
      const response = await api.get('/transfer-rack/items', { params })
      const { data: dataResponse, metadata: metadataResponse } = response.data
      if (dataResponse.length > 0) {
        const newValues = dataResponse.reduce((acc, cur) => {
          const existingGroup = acc.find(
            (item) => item.slot === cur.slot && item.palet_id === cur.palet_id
          )

          if (existingGroup) {
            existingGroup.items.push({
              ...cur,
              picked_pack: cur.total_pack,
              picked_qty: cur.total_qty
            })
          } else {
            acc.push({
              ...cur,
              picked_pack: cur.total_pack,
              picked_qty: cur.total_qty,
              destination_slot: null,
              items: [
                {
                  ...cur,
                  picked_pack: cur.total_pack,
                  picked_qty: cur.total_qty
                }
              ]
            })
          }
          return acc
        }, [])
        setData((prevDataItems) => ({
          ...prevDataItems,
          values: newValues,
          isFetch: true,
          metaData: metadataResponse
        }))
      } else {
        setData((prevDataItems) => ({
          ...prevDataItems,
          values: [],
          isFetch: true,
          metaData: metadataResponse
        }))
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, pallet: false }))
    }
  }
  const getDataSlot = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, slot: true }))
      const params = {
        warehouse_id: state?.warehouse_id || '',
        per_page: data.metaData.per_page || 10,
        page: data.metaData.current_page || 1,
        q: search || '',
        slot_item_id: selectedSlotItemId
      }
      const response = await api.get('/transfer-rack/slots', { params })
      const { data: dataResponse, metadata: metadataResponse } = response.data
      if (dataResponse.length > 0) {
        setData((prevDataItems) => ({
          ...prevDataItems,
          values: dataResponse,
          isFetch: true,
          metaData: metadataResponse
        }))
      } else {
        setData((prevDataItems) => ({
          ...prevDataItems,
          values: dataResponse,
          isFetch: true,
          metaData: metadataResponse
        }))
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, slot: false }))
    }
  }
  const handleChangeCheckbox = (id) => {
    if (!id) {
      if (
        !selected.pallet.length ||
        selected.pallet.length !== data.values?.length
      ) {
        setSelected((prevSelected) => ({
          ...prevSelected,
          pallet: data.values
        }))
      } else {
        setSelected((prevSelected) => ({
          ...prevSelected,
          pallet: []
        }))
      }
    } else {
      const dataSelectedItem = data.values?.find(
        (item) => item.slot_item_id === id
      )
      const newValuesPallet = selected.pallet.find(
        (selectPallet) => selectPallet.slot_item_id === id
      )
        ? selected.pallet.filter(
            (selectPalletFilter) => selectPalletFilter.slot_item_id !== id
          )
        : [...selected.pallet, dataSelectedItem]
      setSelected((prevSelected) => ({
        ...prevSelected,
        pallet: newValuesPallet
      }))
    }
  }
  const handleButtonSelectPallet = () => {
    if (!selected.pallet.length) return true
    const selectedPalletSlotItemId = selected.pallet?.map(
      (pallet) => pallet.slot_item_id
    )?.length
    const payloadPalletSlotItemId = payload.pallet?.map(
      (pallet) => pallet.slot_item_id
    )?.length
    if (selectedPalletSlotItemId === payloadPalletSlotItemId) return true
    return false
  }
  const handleSubmitSelectPallet = () => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      pallet: !prevPayload.pallet?.length
        ? selected.pallet
        : [
            ...prevPayload.pallet,
            ...selected.pallet.filter(
              (selectedPallet) =>
                !prevPayload.pallet.some(
                  (pallet) =>
                    pallet.slot_item_id === selectedPallet.slot_item_id
                )
            )
          ]
    }))
    handleClose()
  }

  const handleSubmitTicket = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, submit: true }))
      const slot_items =
        payload.pallet?.flatMap(({ destination_slot, items }) =>
          items.map(({ slot_item_id, picked_pack }) => ({
            slot_item_id,
            destination: destination_slot?.slot_id,
            total_pack: Number(picked_pack)
          }))
        ) || []
      const payloadBody = {
        warehouse_id: state?.warehouse_id,
        slot_items
      }
      const response = await api.post('/transfer-rack', payloadBody)
      const { success } = response.data
      if (success) {
        toast.success('Ticket Created!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        navigate('/transfer/transfer_antar_rak', {
          state: state
        })
      } else {
        throw new Error('Something went wrong')
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        err?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, submit: false }))
    }
  }

  const handleSearch = (value) => {
    setSearch(value)
    setData((prevData) => ({
      ...prevData,
      metaData: { ...prevData.metaData, current_page: 1 }
    }))
  }

  const debouncedFetch = useCallback(() => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current)

    debounceTimeout.current = setTimeout(() => {
      if (abortControllerRef.current) abortControllerRef.current.abort()

      const controller = new AbortController()
      abortControllerRef.current = controller

      if (visible.pallet && state?.warehouse_id) {
        getDataPallet({ signal: controller.signal }).catch((err) => {
          if (err.name !== 'AbortError') console.error('API Error:', err)
        })
      }
      if (visible.slot && state?.warehouse_id && selectedSlotItemId) {
        getDataSlot({ signal: controller.signal }).catch((err) => {
          if (err.name !== 'AbortError') console.error('API Error:', err)
        })
      }
    }, 1000)
  }, [
    visible.pallet,
    visible.slot,
    state?.warehouse_id,
    selectedSlotItemId,
    search,
    data.metaData.current_page,
    data.metaData.per_page
  ])

  useEffect(() => {
    debouncedFetch()

    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
      if (abortControllerRef.current) abortControllerRef.current.abort()
    }
  }, [debouncedFetch])
  return (
    <Container fluid className="px-4 mb-5">
      <Toaster />
      <Row className="mb-4 align-items-center">
        <Col>
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-column justify-content-start">
              <h3 style={headerTitleStyle}>Create Transfer Pallet Antar Rak</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb fs-6 mb-0">
                  <li className="breadcrumb-item">
                    <Button
                      variant="link"
                      className="p-0 text-decoration-none text-muted"
                      onClick={() =>
                        setVisible((prevVisible) => ({
                          ...prevVisible,
                          cancel: true
                        }))
                      }
                      style={{ fontSize: '14px', fontWeight: '500' }}
                    >
                      Transfer Pallet Antar Rak
                    </Button>
                  </li>
                  <li
                    className="breadcrumb-item active text-muted"
                    aria-current="page"
                    style={{ fontSize: '14px', fontWeight: '500' }}
                  >
                    Create
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row className="align-items-center">
          <Col md={12}>
            <small style={labelStyle}>Warehouse</small>
            <h6 className="mt-1 mb-3" style={{ fontSize: '1.1rem' }}>
              {state?.warehouse_name}
            </h6>
          </Col>
          <Col md={12}>
            <Button
              className="btn-primary-orange text-uppercase fw-bold"
              style={{ fontSize: '0.85rem', padding: '10px 20px' }}
              onClick={() => setVisible({ ...visible, pallet: true })}
            >
              Select Slot
            </Button>
          </Col>
        </Row>
      </Card>

      {payload.pallet.length > 0 && (
        <Row className="mt-4">
          <Col md={12}>
            <Table
              responsive
              className="mb-5 bg-white border"
              style={{ borderRadius: '8px', overflow: 'hidden' }}
            >
              <thead style={{ backgroundColor: '#f4f5f7' }}>
                <tr>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Slot Name
                  </th>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Palet
                  </th>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Area
                  </th>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Destination
                  </th>
                  <th
                    className="p-3 text-muted text-end border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {payload.pallet?.map((item, index) => (
                  <React.Fragment key={index}>
                    {/* Outer Row */}
                    <tr className="bg-white">
                      <td className="p-3 align-middle fw-semibold text-dark">
                        {item.slot || '-'}
                      </td>
                      <td className="p-3 align-middle">
                        {item.palet_id || '-'}
                      </td>
                      <td className="p-3 align-middle">{item.area || '-'}</td>
                      <td className="p-3 align-middle">
                        {!item.destination_slot ? (
                          <Button
                            variant="outline-warning"
                            className="fw-bold"
                            style={{
                              fontSize: '0.8rem',
                              padding: '6px 20px',
                              minWidth: '150px'
                            }}
                            onClick={() => {
                              setSelectedSlotItemId(item.slot_item_id)
                              setVisible((prevVisible) => ({
                                ...prevVisible,
                                slot: true
                              }))
                            }}
                          >
                            SELECT
                          </Button>
                        ) : (
                          <Button
                            variant="outline-warning"
                            className="fw-bold"
                            style={{
                              fontSize: '0.8rem',
                              padding: '6px 20px',
                              minWidth: '150px',
                              color: '#f89d1d'
                            }}
                            onClick={() => {
                              setSelectedSlotItemId(item.slot_item_id)
                              setVisible((prevVisible) => ({
                                ...prevVisible,
                                slot: true
                              }))
                            }}
                          >
                            {item.destination_slot.slot || ''}
                          </Button>
                        )}
                      </td>
                      <td className="p-3 align-middle text-end">
                        <Button
                          variant="danger"
                          className="fw-bold"
                          size="sm"
                          style={{ fontSize: '0.75rem', padding: '6px 12px' }}
                          onClick={() =>
                            handleRemoveDataTransfer(item.slot_item_id)
                          }
                        >
                          REMOVE
                        </Button>
                      </td>
                    </tr>
                    {/* Inner Table Row */}
                    <tr>
                      <td colSpan={5} className="p-0 border-0">
                        <Table
                          responsive
                          className="mb-4 mx-auto"
                          style={{
                            width: '98%',
                            backgroundColor: '#fcfcfc',
                            border: '1px solid #eee'
                          }}
                        >
                          <thead>
                            <tr style={{ backgroundColor: '#f4f5f7' }}>
                              <th
                                className="p-3 text-muted"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Item Code - Name
                              </th>
                              <th
                                className="p-3 text-muted"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Batch
                              </th>
                              <th
                                className="p-3 text-muted"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Exp Date
                              </th>
                              <th
                                className="p-3 text-muted"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Available
                                <br />
                                Qty Kemasan
                              </th>
                              <th
                                className="p-3 text-muted"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Available Base
                                <br />
                                Qty UOM
                              </th>
                              <th
                                className="p-3 text-muted"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Picked
                                <br />
                                Qty Kemasan
                              </th>
                              <th
                                className="p-3 text-muted"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Picked Base
                                <br />
                                Qty UOM
                              </th>
                              <th
                                className="p-3 text-muted text-end"
                                style={{
                                  fontWeight: '700',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.items.map((subItem, subIndex) => (
                              <tr
                                key={subIndex}
                                className="bg-white border-bottom"
                              >
                                <td
                                  className="p-3 align-middle text-dark fw-semibold"
                                  style={{ fontSize: '0.85rem' }}
                                >
                                  {subItem.item_code} - {subItem.item_name}
                                </td>
                                <td
                                  className="p-3 align-middle text-dark"
                                  style={{ fontSize: '0.85rem' }}
                                >
                                  {subItem.batch || '-'}
                                </td>
                                <td
                                  className="p-3 align-middle text-dark"
                                  style={{ fontSize: '0.85rem' }}
                                >
                                  {subItem.exp_date || '-'}
                                </td>
                                <td
                                  className="p-3 align-middle text-dark"
                                  style={{ fontSize: '0.85rem' }}
                                >{`${parseFloat(subItem.total_pack || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ${subItem.uom_pack || ''}`}</td>
                                <td
                                  className="p-3 align-middle text-dark"
                                  style={{ fontSize: '0.85rem' }}
                                >{`${parseFloat(subItem.total_qty || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${subItem.uom_qty || ''}`}</td>
                                <td
                                  className="p-3 align-middle text-dark"
                                  style={{ fontSize: '0.85rem' }}
                                >
                                  <span
                                    style={{
                                      backgroundColor: '#e2e3e5',
                                      color: '#495057',
                                      padding: '6px 10px',
                                      borderRadius: '4px',
                                      fontWeight: '600'
                                    }}
                                  >
                                    {`${parseFloat(subItem.picked_pack || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ${subItem.uom_pack || ''}`}
                                  </span>
                                </td>
                                <td
                                  className="p-3 align-middle text-dark"
                                  style={{ fontSize: '0.85rem' }}
                                >
                                  <span
                                    style={{
                                      backgroundColor: '#e2e3e5',
                                      color: '#495057',
                                      padding: '6px 10px',
                                      borderRadius: '4px',
                                      fontWeight: '600'
                                    }}
                                  >
                                    {`${parseFloat(subItem.picked_qty || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${subItem.uom_qty || ''}`}
                                  </span>
                                </td>
                                <td className="p-3 align-middle text-end">
                                  <div className="d-flex justify-content-end gap-2">
                                    <Button
                                      variant="secondary"
                                      size="sm"
                                      disabled={Number(subItem.total_pack) <= 1}
                                      onClick={() =>
                                        handleOpenEditModal(subItem)
                                      }
                                      style={{
                                        backgroundColor: '#8e8e8e',
                                        border: 'none',
                                        padding: '6px'
                                      }}
                                    >
                                      <Edit2 size={14} color="white" />
                                    </Button>
                                    <Button
                                      variant="danger"
                                      size="sm"
                                      onClick={() =>
                                        handleRemoveSubItem(
                                          item.slot_item_id,
                                          subItem.slot_item_id
                                        )
                                      }
                                      style={{ padding: '6px' }}
                                    >
                                      <Trash2 size={14} />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      )}
      <Row className="mt-2">
        <Col md={12}>
          <div className="d-flex justify-content-between">
            <Button
              type="button"
              variant="light"
              className="text-danger fw-bold border"
              onClick={() =>
                setVisible((prevVisible) => ({
                  ...prevVisible,
                  cancel: true
                }))
              }
            >
              Cancel
            </Button>
            <Button
              className={`${
                payload.pallet.some((pallet) => !pallet.destination_slot) ||
                !payload.pallet.length
                  ? 'btn-secondary opacity-25'
                  : 'btn-primary-orange'
              } fw-bold`}
              disabled={
                payload.pallet.some((pallet) => !pallet.destination_slot) ||
                !payload.pallet.length
                  ? true
                  : false
              }
              onClick={() =>
                setVisible((prevVisible) => ({
                  ...prevVisible,
                  create: true
                }))
              }
            >
              Submit
            </Button>
          </div>
        </Col>
      </Row>
      <ModalStockAdjustment
        show={Object.values(visible).includes(true)}
        title={getDataModal()?.title}
        onHide={handleClose}
        size={getDataModal()?.size}
      >
        <div className="d-flex w-100 justify-content-end my-3">
          <div className="d-flex flex-row gap-2 my-2 justify-content-end">
            {(visible.pallet || visible.slot) && (
              <InputGroup className="mb-3" style={{ width: '300px' }}>
                <Form.Control
                  type="text"
                  placeholder={`${
                    visible.pallet
                      ? 'Search Slot / Pallet'
                      : 'Search by Code Slot'
                  }`}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <InputGroup.Text>
                  <Search size={14} />
                </InputGroup.Text>
              </InputGroup>
            )}
            {visible.pallet && (
              <div>
                <Button
                  className={`${
                    !handleButtonSelectPallet()
                      ? 'btn-primary-orange'
                      : 'btn-secondary opacity-25'
                  }`}
                  disabled={handleButtonSelectPallet()}
                  onClick={handleSubmitSelectPallet}
                >
                  Submit
                </Button>
              </div>
            )}
          </div>
        </div>
        <Row style={{ overflowY: 'auto', maxHeight: '70vh' }}>
          {visible.pallet && (
            <Table
              responsive="md"
              className="shadow-sm mb-5 bg-white rounded"
              style={{ fontSize: '14px' }}
            >
              <thead className="table-secondary">
                <tr>
                  {COLUMN_PALLET.map((columnPallet) => (
                    <th className="align-middle p-2" key={columnPallet.key}>
                      {columnPallet.key === 'checkbox' && (
                        <input
                          type="checkbox"
                          className="staging-area form-check-input"
                          checked={
                            data.values?.length !== 0 &&
                            data.values?.length === selected.pallet?.length
                          }
                          disabled={!data.values?.length}
                          onChange={() => handleChangeCheckbox()}
                          role="button"
                        />
                      )}
                      {columnPallet.key !== 'checkbox' && (
                        <span>{columnPallet.label}</span>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(loading.pallet || !data.isFetch) && (
                  <tr>
                    <td
                      colSpan={COLUMN_PALLET.length}
                      className="p-2 text-center"
                    >
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading.pallet && !data.values?.length && data.isFetch && (
                  <RowEmpty colSpan={COLUMN_PALLET.length} />
                )}
                {!loading.pallet &&
                  data.values?.length > 0 &&
                  data.isFetch &&
                  data.values?.map((item, index) => (
                    <>
                      <tr key={index}>
                        {COLUMN_PALLET.map((column) => (
                          <td
                            key={column.key}
                            className="p-2 align-middle"
                            rowSpan={
                              (column.key === 'checkbox' ||
                                column.key === 'slot') &&
                              item.items.length > 1
                                ? item.items.length
                                : 1
                            }
                          >
                            {column.key === 'checkbox' && (
                              <input
                                type="checkbox"
                                className="add-item-adjustment form-check-input"
                                role="button"
                                onChange={() =>
                                  handleChangeCheckbox(item.slot_item_id)
                                }
                                checked={
                                  selected.pallet.find(
                                    (selectId) =>
                                      selectId?.slot_item_id ===
                                      item?.slot_item_id
                                  )
                                    ? true
                                    : false
                                }
                                disabled={payload.pallet.find(
                                  (payloadItem) =>
                                    payloadItem?.slot_item_id ===
                                    item?.slot_item_id
                                )}
                              />
                            )}
                            {column.component && column.component(item)}
                            {column.key !== 'action' &&
                              !column.component &&
                              column.key !== 'checkbox' &&
                              (item[column.key] ?? '-')}
                          </td>
                        ))}
                      </tr>

                      {/* Render additional rows for item.items (skipping the first one since it's already rendered above) */}
                      {item.items?.length > 1 &&
                        item.items?.slice(1).map((subItem, subIndex) => (
                          <tr key={`${index}-sub-${subIndex}`}>
                            {COLUMN_PALLET.map((subColumnPallet) =>
                              subColumnPallet.key !== 'checkbox' &&
                              subColumnPallet.key !== 'slot' ? (
                                <td
                                  key={subColumnPallet.key}
                                  className="p-2 align-middle"
                                >
                                  {subColumnPallet.component
                                    ? subColumnPallet.component(subItem)
                                    : (subItem[subColumnPallet.key] ?? '-')}
                                </td>
                              ) : null
                            )}
                          </tr>
                        ))}
                    </>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3" colSpan={COLUMN_PALLET.length}>
                    <TablePagination
                      meta={data.metaData}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          )}
          {visible.slot && (
            <Table
              responsive="md"
              className="shadow-sm mb-5 bg-white rounded"
              style={{ fontSize: '14px' }}
            >
              <thead className="table-secondary">
                <tr>
                  {COLUMN_SLOT.map((columnSlot) => (
                    <th className="align-middle p-2" key={columnSlot.key}>
                      <span>{columnSlot.label}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(loading.slot || !data.isFetch) && (
                  <tr>
                    <td
                      colSpan={COLUMN_SLOT.length}
                      className="p-2 text-center"
                    >
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading.slot && !data.values?.length && data.isFetch && (
                  <RowEmpty colSpan={COLUMN_SLOT.length} />
                )}
                {!loading.slot &&
                  data.values?.length > 0 &&
                  data.isFetch &&
                  data.values?.map((item, index) => (
                    <>
                      <tr key={index}>
                        {COLUMN_SLOT.map((column) => (
                          <td key={column.key} className="p-2 align-middle">
                            {column.component && column.component(item)}
                            {column.key !== 'action' &&
                              !column.component &&
                              (item[column.key] ?? '-')}
                          </td>
                        ))}
                      </tr>
                    </>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3" colSpan={COLUMN_SLOT.length}>
                    <TablePagination
                      meta={data.metaData}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          )}
          {(visible.cancel || visible.create) && (
            <div className="p-2 mt-3 text-center">
              <div className="d-flex justify-content-center">
                <svg
                  width="181"
                  height="180"
                  viewBox="0 0 181 180"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                    fill="#828282"
                  />
                  <path
                    d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                    fill="#828282"
                  />
                </svg>
              </div>
              <div className="my-3">
                {visible.cancel && (
                  <>
                    <h6>Cancel?</h6>
                    <p>All data will be deleted, cancel creating ticket?</p>
                  </>
                )}
                {visible.create && <h6>Create?</h6>}
              </div>
              <Modal.Footer className="mt-4">
                <div className="d-flex flex-column align-items-end justify-content-end h-100 mt-3">
                  <div className="d-flex gap-2">
                    <Button variant="transparent" onClick={handleClose}>
                      {visible.cancel && 'Continue Creating'}
                      {visible.create && 'Cancel'}
                    </Button>
                    {visible.cancel && (
                      <Button
                        className="btn-primary-orange"
                        onClick={() => {
                          navigate('/transfer/transfer_antar_rak', {
                            state: state
                          })
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                    {visible.create && (
                      <Button
                        className={`${
                          loading.submit
                            ? 'btn-secondary opacity-25'
                            : 'btn-primary-orange'
                        }`}
                        disabled={loading.submit}
                        onClick={() => handleSubmitTicket()}
                      >
                        Create Ticket
                      </Button>
                    )}
                  </div>
                </div>
              </Modal.Footer>
            </div>
          )}
        </Row>
      </ModalStockAdjustment>
      <Modal
        show={showUpdateModal}
        onHide={() => setShowUpdateModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title
            style={{ fontSize: '1rem', fontWeight: '700', color: '#333' }}
          >
            Update Item
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          {editingItem && (
            <>
              <div className="mb-3 p-3 bg-light rounded-3">
                <div style={labelStyle}>Item Code – Name</div>
                <div
                  style={{
                    fontWeight: '600',
                    color: '#333',
                    fontSize: '0.88rem'
                  }}
                >
                  {editingItem.item_code} – {editingItem.item_name}
                </div>
              </div>

              <Row className="g-3 mb-3">
                <Col md={6}>
                  <div style={labelStyle}>Batch</div>
                  <div style={{ fontWeight: '600', color: '#333' }}>
                    {editingItem.batch || '-'}
                  </div>
                </Col>
                <Col md={6}>
                  <div style={labelStyle}>Source Slot</div>
                  <div style={{ fontWeight: '600', color: '#333' }}>
                    {editingItem.slot || '-'}
                  </div>
                </Col>
              </Row>

              <Row className="g-3 mb-3">
                <Col md={6}>
                  <div style={labelStyle}>Available Base UOM Qty</div>
                  <div
                    style={{
                      background: '#f8f9fa',
                      borderRadius: '8px',
                      padding: '10px 14px',
                      fontWeight: '600',
                      fontSize: '0.9rem',
                      color: '#333'
                    }}
                  >
                    {`${parseFloat(editingItem.total_qty || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${editingItem.uom_qty || ''}`}
                  </div>
                </Col>
                <Col md={6}>
                  <div style={labelStyle}>Available Qty Kemasan</div>
                  <div
                    style={{
                      background: '#f8f9fa',
                      borderRadius: '8px',
                      padding: '10px 14px',
                      fontWeight: '600',
                      fontSize: '0.9rem',
                      color: '#333'
                    }}
                  >
                    {`${parseFloat(editingItem.total_pack || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ${editingItem.uom_pack || ''}`}
                  </div>
                </Col>
              </Row>

              <Row className="g-3 mb-2">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>
                      Picked Base UOM Qty{' '}
                      <sup style={{ color: 'var(--primary-orange)' }}>*</sup>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.01"
                      value={editPickedQty}
                      onChange={(e) => handleEditQtyChange(e.target.value)}
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #f89d1d',
                        fontWeight: '600',
                        background: '#fff8f0'
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>
                      Picked Qty Kemasan{' '}
                      <sup style={{ color: 'var(--primary-orange)' }}>*</sup>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.0001"
                      value={editPickedPack}
                      onChange={(e) => handleEditPackChange(e.target.value)}
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #f89d1d',
                        fontWeight: '600',
                        background: '#fff8f0'
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                * Changing one field will automatically update the other
              </small>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            onClick={() => setShowUpdateModal(false)}
            style={{ borderRadius: '8px', fontWeight: '600' }}
          >
            Cancel
          </Button>
          <Button
            variant="warning"
            className="text-white fw-bold"
            onClick={handleSaveEdit}
            style={{ borderRadius: '8px', minWidth: '80px' }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default CreateTransferRackPage
